// extracted by mini-css-extract-plugin
export var content = "input-module--content--8cd68";
export var input = "input-module--input--8b691";
export var inputW = "input-module--inputW--65ac0";
export var warning = "input-module--warning--97681";
export var wrapper = "input-module--wrapper--f1495";
export var wrapperCheckbox = "input-module--wrapperCheckbox--a05de";